import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "as-tab-bar" }
const _hoisted_2 = { class: "as-sort-by" }
const _hoisted_3 = { class: "as-with-by" }
const _hoisted_4 = { class: "as-statics-scores" }
const _hoisted_5 = { class: "as-statics-scores__item" }
const _hoisted_6 = { class: "as-number-scores as-score-win" }
const _hoisted_7 = { class: "__win" }
const _hoisted_8 = { class: "as-statics-scores__item" }
const _hoisted_9 = { class: "as-number-scores as-score-win" }
const _hoisted_10 = { class: "__lose" }
const _hoisted_11 = { class: "as-h2h as-scrolling as-scrolling__have-tab as-scrolling__result-popup" }
const _hoisted_12 = { class: "as-h2-title-box" }
const _hoisted_13 = { class: "as-h2-title-box" }

import { ref, computed } from "vue";
import H2hTab from "~src/components/h2h/badminton/H2hTab.vue";
import IconChecked from "~src/components/icons/IconChecked.vue";
import { getIdsTournaments, parseMatchH2hData } from "~src/helpers/badminton";
import { usecommonStore } from "~src/stores/CommonStore";
import IConSort from "~src/components/icons/IConSort.vue";
import TabsBtn from "~src/components/TabsBtn.vue";

const __default__ = {};

interface IProps {
  h2h: any;
  match: any;
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'H2hList',
  props: {
    h2h: {},
    match: {}
  },
  setup(__props: any) {

const commonStore = usecommonStore();

const props = __props;

const siteName = computed(() => commonStore.getSiteName);
const activeTab = ref("vs");
const filterGround = ref(0);
const filterIsSingles = ref(
  props.match.away_team?.sub_ids.length && props.match.home_team?.sub_ids.length
    ? false
    : true
);

const tabs = ref([
  {
    title: props.match.home_team.short_name_vi || props.match.home_team.name,
    key: "home",
  },
  {
    title: "Toàn bộ",
    key: "vs",
  },
  {
    title: props.match.away_team.short_name_vi || props.match.away_team.name,
    key: "away",
  },
]);

const numberWins = computed(() => {
  return getWinsLoses();
});

const numberLoses = computed(() => {
  return getWinsLoses("lose");
});

const getWinsLoses = (mode: string = "win") => {
  let number = 0;
  let data: any[] = [];

  if (activeTab.value === "home") {
    data = h2hHome.value;
  } else if (activeTab.value === "away") {
    data = h2hAway.value;
  } else if (activeTab.value === "vs") {
    data = [...h2hHome.value, ...h2hAway.value];
  }

  if (data) {
    data.forEach((item: any) => {
      const __item = parseMatchH2hData(item, props.match.home_team?.id);
      if (
        (__item?.match_time_player as { text: string; status_h2h: string })
          ?.status_h2h === mode
      ) {
        number += 1;
      }
    });
  }

  return number;
};

const changeTab = (val: string) => {
  activeTab.value = val;
};

const h2hVs = computed(() => {
  if (!props.h2h || !Array.isArray(props.h2h.vs)) {
    return [];
  }

  return props.h2h.vs
    .filter((item: any) => {
      let check = true;

      if (check && activeTab.value === "home") {
        check = props.match.home_team?.id === item.home_team_id;
      }
      if (check && activeTab.value === "away") {
        check = props.match.away_team?.id === item.away_team_id;
      }

      if (filterIsSingles.value) {
        check =
          item.home_team.sub_ids.length === 0 &&
          item.away_team.sub_ids.length === 0;
      } else {
        check =
          item.home_team.sub_ids.length > 0 &&
          item.away_team.sub_ids.length > 0;
      }

      return check;
    })
    .sort((a: any, b: any) => {
      return a.match_time > b.match_time ? -1 : 1;
    });
});

const h2hHome = computed(() => {
  if (!props.h2h || !Array.isArray(props.h2h.home)) {
    return [];
  }

  return props.h2h.home
    .filter((item: any) => {
      let check = true;

      if (check && filterIsSingles.value) {
        check =
          item.home_team.sub_ids.length === 0 &&
          item.away_team.sub_ids.length === 0;
      } else {
        check =
          item.home_team.sub_ids.length > 0 &&
          item.away_team.sub_ids.length > 0;
      }

      return check;
    })
    .sort((a: any, b: any) => {
      return a.match_time > b.match_time ? -1 : 1;
    });
});

const h2hAway = computed(() => {
  if (!props.h2h || !Array.isArray(props.h2h.away)) {
    return [];
  }

  return props.h2h.away
    .filter((item: any) => {
      let check = true;

      if (check && filterIsSingles.value) {
        check =
          item.home_team.sub_ids.length === 0 &&
          item.away_team.sub_ids.length === 0;
      } else {
        check =
          item.home_team.sub_ids.length > 0 &&
          item.away_team.sub_ids.length > 0;
      }

      return check;
    })
    .sort((a: any, b: any) => {
      return a.match_time > b.match_time ? -1 : 1;
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`as-parent-h2h as-parent-h2h-${siteName.value}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TabsBtn, {
        tabs: tabs.value,
        activeTab: activeTab.value,
        onChange: changeTab,
        isShowBorder: true
      }, null, 8, ["tabs", "activeTab"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (filterIsSingles.value = !filterIsSingles.value))
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(filterIsSingles.value ? "Đánh đơn" : "Đánh đội"), 1),
          _createVNode(IConSort)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "__title" }, "Thắng", -1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(numberWins.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "__title" }, "Thua", -1)),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(numberLoses.value), 1)
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "as-h2-title-box" }, "Các trận đối đầu", -1)),
      (_openBlock(), _createBlock(H2hTab, {
        h2h: h2hVs.value,
        teams: _ctx.h2h.teams,
        competitions: _ctx.h2h.tournaments,
        match: _ctx.match,
        tab: "all",
        homeTeamId: _ctx.match.home_team_id,
        key: activeTab.value
      }, null, 8, ["h2h", "teams", "competitions", "match", "homeTeamId"]))
    ], 512), [
      [_vShow, activeTab.value === 'vs']
    ]),
    _createElementVNode("div", _hoisted_11, [
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_12, " Các trận gần nhất: " + _toDisplayString(_ctx.match.home_team.name), 1),
        (_openBlock(), _createBlock(H2hTab, {
          h2h: h2hHome.value,
          teams: _ctx.h2h.teams,
          competitions: _ctx.h2h.tournaments,
          match: _ctx.match,
          tab: "home",
          homeTeamId: _ctx.match.home_team_id,
          key: activeTab.value
        }, null, 8, ["h2h", "teams", "competitions", "match", "homeTeamId"]))
      ], 512), [
        [_vShow, activeTab.value !== 'away']
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_13, " Các trận gần nhất: " + _toDisplayString(_ctx.match.away_team.name), 1),
        (_openBlock(), _createBlock(H2hTab, {
          h2h: h2hAway.value,
          teams: _ctx.h2h.teams,
          competitions: _ctx.h2h.tournaments,
          match: _ctx.match,
          tab: "away",
          homeTeamId: _ctx.match.away_team_id,
          key: activeTab.value
        }, null, 8, ["h2h", "teams", "competitions", "match", "homeTeamId"]))
      ], 512), [
        [_vShow, activeTab.value !== 'home']
      ])
    ])
  ], 2))
}
}

})